export default __webpack_public_path__ + "static/media/warrior-pepe.5709c12f.jpeg";